const equipmentBadgeStatus = {
  inactive: 'Inativo',
  maintenance: 'Manutenção',
  valid: 'Válido',
  invalid: 'Inválido',
  validWithOpenedActions: 'Válido*',
};

export default equipmentBadgeStatus;